import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CasePaymentsResult } from "../models/tr-cr-lookup/case-payments";
import { QueryCivilDailyResult } from "../models/civil-query/civil-daily-query";
import { QueryArraignmentResult } from "../models/TR-CR-Query/Query-Arraignment-Result";
import { QueryAttorneyResult } from "../models/TR-CR-Query/Query-Attoryney-Result";
import { QueryDailyResult } from "../models/TR-CR-Query/Query-Daily-Result";
import { QueryListResult } from "../models/TR-CR-Query/Query-List-Result";
import { QueryOfficerResult } from "../models/TR-CR-Query/Query-Officer-Result";
import { courtConnectBaseUrl } from "./connect-api";
import { QueryCivilAttorneyResult } from "../models/civil-query/QueryCivilAttorneyResult";

export const queryApis = createApi({
  reducerPath: "queryApis",
  baseQuery: fetchBaseQuery({
    baseUrl: courtConnectBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS");

      return headers;
    }
  }),
  endpoints: (builder) => ({
    queryList: builder.mutation<QueryListResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryList"
      })
    }),
    trCrDailyList: builder.mutation<QueryDailyResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryDaily"
      })
    }),
    trCrArraignmentList: builder.mutation<QueryArraignmentResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryArraignment"
      })
    }),
    trCrAttorneyList: builder.mutation<QueryAttorneyResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryAttorney"
      })
    }),
    trCrAgencyList: builder.mutation<QueryOfficerResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryAgency"
      })
    }),
    paymentAPI: builder.mutation<CasePaymentsResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "PayableAmounts"
      })
    }),
    civilDailyQuery: builder.mutation<QueryCivilDailyResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryCivilDailyResult"
      })
    }),
    civilAttorneyQuery: builder.mutation<QueryCivilAttorneyResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "QueryCivilAttorney"
      })
    })
  })
});

export const { useQueryListMutation, useTrCrDailyListMutation, useTrCrArraignmentListMutation, useTrCrAttorneyListMutation, useTrCrAgencyListMutation, usePaymentAPIMutation, useCivilDailyQueryMutation, useCivilAttorneyQueryMutation } = queryApis;
